import {useGemStore} from 'app/gemStore';

export function useLazyLoadPage() {
    return useGemStore((state) => state.lazyLoadPage);
}
